<ng-template #gdlBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? (saveFirstLabelKey | translate)
                : (missingDataLabelKey | translate)
        "
        [loading]="isSaving"
        icon="fa fa-save"
        [label]="saveFirstLabelKey | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div #gdlBlock [blocked]="!model.id" [blockUi]="gdlBlockUi">
    @if (model.id) {
        <app-widget-generic-document-list
            [autoFocusSearch]="false"
            [fillHeightList]="fillHeightList"
            [noAddNew]="true"
            [noDelete]="true"
            [noCopy]="true"
            [noBaseEdit]="true"
            [addressId]="props?.externalModelType === 'ADDRESS' ? model.id : null"
            [projectId]="props?.externalModelType === 'DOCUMENT_PROJECT' ? model.id : null"
            [successorOfDocumentId]="props?.externalModelType === 'CONTRACT' ? model.id : null"
            [viewName]="this.props?.viewName"
            [deactivateControls]="true"
            [noDocumentTypeDropdown]="false"
        />
    }
</blockable-div>
